import React, { useEffect, useState } from 'react';
import HEADER from "../Components/header";
import { useForm, SubmitHandler } from 'react-hook-form';
import INFOADMINMODAL from '../Components/InfoAdmin/Modal/InfoAdminModalAction';
import MAILADMINMODAL from '../Components/InfoAdmin/Modal/MailAdminModal';
import { useNavigate } from 'react-router-dom'
import infoKindConsts from "../Consts/infoKinds";
import {useCookies} from "react-cookie";
import Utility from 'Consts/Utility';
import {ApiRequest} from "../Consts/ApiRequest";
import MessageComponent from "../Components/MessageComponent";
type infoInputs = {
    infoDetail: {
        link: string;
        message: string;
        linkMessage: string;
    };
    infoKind: string;
    isComplete: boolean;
    isLineNotify: boolean,
    infoDatetime: {
        start: string;
        end: string;
    };
    infoRecno: number;
};

type InfoCheckedKind = {
    label: string;
    num: number;
    checked: boolean;
};

const InfoAdmin = () => {
    const navigate = useNavigate();
    const [infoData, setInfoData] = useState<infoInputs[]>([]);
    const [start, setStart] = useState<string>("");
    const [end, setEnd] = useState<string>("");
    const [message, setMessage] = useState<string>("");
    const [infoRecno, setInfoRecno] = useState<number>(0);
    const [infoKind, setInfoKind] = useState<string>("2");
    const [error, setError] = useState<string[]>([]);

    // お知らせチェックボックス
    const [infoCheckedKinds, setinfoCheckedKinds] = useState<InfoCheckedKind[]>([
        { label: "お知らせ", num: 0, checked: false },
        { label: "障害情報", num: 1, checked: false },
    ]);
    const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', 'siteId', 'siteRecno']);

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newinfoCheckedKinds = infoCheckedKinds.map((InfoCheckedKind) => {
            if (InfoCheckedKind.label === e.target.value) {
                return { ...InfoCheckedKind, checked: !InfoCheckedKind.checked };
            }
            return InfoCheckedKind;
        });
        setinfoCheckedKinds(newinfoCheckedKinds);

        // 選択されたお知らせの種別をセット
        const checkedItems = newinfoCheckedKinds.filter(item => item.checked).map(item => item.num);

        if (checkedItems.length === 2) {
            setInfoKind("2");
        } else {
            setInfoKind(checkedItems.length === 1 ? String(checkedItems[0]) : "2");
        }
    };

    const { register, handleSubmit, formState: { errors } } = useForm<infoInputs>();
    const [checkboxValue, setCheckboxValue] = useState<number>();
    function handleCheckboxChange(event: React.ChangeEvent<HTMLInputElement>) {
        const value = event.target.value;
        setCheckboxValue(parseInt(value));
    }

    const [state, setState] = useState("aaa")
    const changeState = (isState: string) => {
        setState(isState)
        getInfo();
    }

    const onClose = () => {
        getInfo();
    }

    const getParam = () => {
        const StartReformattedDate = Utility.ReformatDate(start == "" ? "1900-01-01" : start);
        const EndReformattedDate = Utility.ReformatDate(end == "" ? "2100-01-01" : end);
        let params = {
            "prcKind": 1,
            "infoDatetime": {
                "start": StartReformattedDate,
                "end": EndReformattedDate,
            },
            "infoDetail": {
                "message": message,
            },
            "infoKind": Number(infoKind ?? "2"),
        };
        return params;
    }

    const getInfo = async () => {
        setInfoData([]);
        const token = cookies.access_token || "";
        ApiRequest.getInfo(getParam(), token, (response: any)=>{
            if (response.data.infos) {
                setInfoData(response.data.infos);
            }
        }, (error:any) => {
            errorCallback(error);
        });
    }

    useEffect(() => {
        if(cookies.authority == 2 || cookies.authority == 3 || cookies.authority == 4) {
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        // ログアウトしていたら「ログイン」に遷移
        if(!cookies.access_token) navigate("/login");
        const token = cookies.access_token || "";
        ApiRequest.getInfo(getParam(), token, (response: any)=>{
            if (response.data.infos) {
                setInfoData(response.data.infos);
            }
        },(error:any) => {
                errorCallback(error);
            });
    }, []);

    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

    const onSubmit: SubmitHandler<infoInputs> = async (data) => {
        try {
            const token = cookies.access_token || "";
            ApiRequest.getInfo(getParam(), token, (response:any) => {
                if (Array.isArray(response.data.infos)) {
                    setInfoData(response.data.infos);
                }
            }, (error:any) => {
                errorCallback(error);
            })
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    return (
        <>
            <div className="wrapper">
                <HEADER />
                <main className="main">
                    <section className="page-head" id="page-head">
                        <div className="page-head-block">
                            <div className="page-name">
                                <a onClick={() => navigate(-1)}><img src="https://www.sooki-cloud-portalsystem.jp/static/media/icon-back-b.a302f48a196965a4ff8d4568031a609b.svg" alt="戻る" /></a>
                                <div className="page-name-label">お知らせ管理</div>
                            </div>
                            <div className="page-option">
                                <MAILADMINMODAL />
                                <INFOADMINMODAL
                                    start={""}
                                    end={""}
                                    prcKind={0}
                                    infoKind={0}
                                    infoRecno={0}
                                    message={""}
                                    link={""}
                                    linkMessage={""}
                                    isLineNotify={false}
                                    setState={changeState}
                                    onClose={onClose}
                                />
                            </div>
                        </div>
                    </section>
                    <section className="page-body scroll-block">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="search-box">
                                <div className="search-box-elm">
                                    <div className="search-box-elm-name">対象期間</div>
                                    <div className="search-box-elm-input">
                                        <input
                                            type="date"
                                            value={start}
                                            placeholder="start"
                                            min="0000-01-01"
                                            max="9999-12-31"
                                            {...register("infoDatetime.start",)}
                                            className="col-320 error-disp"
                                            onChange={e => setStart(e.target.value)}
                                        />
                                        {errors.infoDatetime?.start &&
                                            <p className="error-msg">{errors.infoDatetime.start.message}</p>}
                                    </div>
                                </div>
                                <div><small>～</small></div>
                                <div className="search-box-elm">
                                    <div className="search-box-elm-input">
                                        <input
                                            type="date"
                                            value={end}
                                            placeholder="end"
                                            min="0000-01-01"
                                            max="9999-12-31"
                                            {...register("infoDatetime.end")
                                            }
                                            className="col-320 error-disp"
                                            onChange={e => setEnd(e.target.value)}
                                        />
                                        {errors.infoDatetime?.end &&
                                            <p className="error-msg">{errors.infoDatetime.end.message}</p>}
                                    </div>
                                </div>
                                <div className="search-box-elm">
                                    <div className="search-box-elm-name">メッセージ（部分一致）</div>
                                    <div className="search-box-elm-input">
                                        <input
                                            type="text"
                                            value={message}
                                            placeholder="message"
                                            {...register("infoDetail.message")}
                                            onChange={e => setMessage(e.target.value)}
                                        />
                                    </div>
                                </div>
                                <div className="search-box-elm">
                                    <div className="search-box-elm-name">種別</div>
                                    <div className="search-box-elm-items" style={{ display: 'flex',gap:'10px'}}>
                                        {infoCheckedKinds.map((infoCheckedKind) => (
                                            <div
                                                className="search-box-elm-input"
                                                key={infoCheckedKind.label}>
                                                <input
                                                    id={infoCheckedKind.label}
                                                    type="checkbox"
                                                    value={infoCheckedKind.label}
                                                    onChange={onChange}
                                                />
                                                <label htmlFor={infoCheckedKind.label}>
                                                    {infoCheckedKind.label}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="search-box-btn">
                                    <button className="btn btn-white-line">
                                        <i className="icon-search-w"></i>検索</button>
                                </div>
                            </div>
                        </form>
                        <div className="table-box">
                            <table className="st-table">
                                <thead>
                                    <tr>
                                        <th className="">開始日</th>
                                        <th className="">終了日</th>
                                        <th className="">種別</th>
                                        <th className="">メッセージ</th>
                                        <th className="">LINE通知</th>
                                        <th className="">通知完了</th>
                                        <th className="col-100">編集</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {infoData.map((item, index) => (
                                        <tr key={item.infoRecno}>
                                            <td className="nowrap">{item.infoDatetime.start}</td>
                                            <td className="nowrap">{item.infoDatetime.end}</td>
                                            <td className="nowrap">{infoKindConsts.getInfoKind(Number(item.infoKind))}</td>
                                            <td className="nowrap">
                                                <MessageComponent message={item.infoDetail.message} maxLength={60}/>
                                            </td>
                                            <td className="nowrap">{item.isLineNotify ?
                                                <i className="icon-check-b"></i> : null}
                                            </td>
                                            <td className="nowrap">{item.isComplete ?
                                                <i className="icon-check-b"></i> : null}
                                            </td>
                                            <td>
                                                <INFOADMINMODAL
                                                    start={item.infoDatetime.start}
                                                    end={item.infoDatetime.end}
                                                    infoKind={Number(item.infoKind)}
                                                    infoRecno={item.infoRecno}
                                                    message={item.infoDetail.message}
                                                    link={item.infoDetail.link}
                                                    linkMessage={item.infoDetail.linkMessage}
                                                    prcKind={1}
                                                    isLineNotify={item.isLineNotify}
                                                    setState={changeState}
                                                    onClose={onClose}
                                                />
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </section>
                </main>
            </div>
        </>
    );
};
export default InfoAdmin;
